import { useState } from 'react';

import CnhTutorialUploadFile from './CnhTutorialUploadFile';
import CnhCamera from './CnhCamera';

type TPageMode = 'tutorial-upload-file' | 'camera';

function Cnh() {
  const [mode, setMode] = useState<TPageMode>('tutorial-upload-file');

  return (
    <>
      {mode === 'tutorial-upload-file' && (
        <CnhTutorialUploadFile onClickOpenCamera={() => setMode('camera')} />
      )}
      {mode === 'camera' && (
        <CnhCamera onClickCloseCamera={() => setMode('tutorial-upload-file')} />
      )}
    </>
  );
}

export default Cnh;
